import { FC } from 'react';
import { Link } from '@zoopla-eng/zds-components/link';
import triggerTracking from '@blueprint/tracking';

type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

const EntryHyperlink: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    const articleCategory =
        nodeData?.data?.target?.fields?.category.fields?.slug;
    const entryLinkHref = `/discover/${articleCategory}/${nodeData?.data?.target?.fields?.slug}/`;

    return (
        <Link
            href={`${entryLinkHref}`}
            onClick={function () {
                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'discover',
                    eventAction: 'clickthrough',
                    eventLabel: `body link,${entryLinkHref}`
                });
            }}
        >
            {nodeData?.content[0]?.value}
        </Link>
    );
};

export default EntryHyperlink;
